import { render, staticRenderFns } from "./dryProductStock.vue?vue&type=template&id=5045ed5a&"
import script from "./dryProductStock.vue?vue&type=script&lang=js&"
export * from "./dryProductStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports